import React from "react";

import Divider from "@material-ui/core/Divider";
import styled from "styled-components/macro";

import { logoColor } from "constants/theme";

import { useIsMobile } from "hooks";

import {
  LogoFull,
  LogoSmall,
  ChristmasLogoFull,
  ChristmasLogoSmall,
  SidebarLogo,
} from "./SidebarLogo";

const LogoWrapper = styled.div`
  padding-top: 15px;
  padding-bottom: 30px;
  margin-bottom: 40px;
`;

const PreviewWrapper = styled.div`
  font-size: 10px;
  font-weight: bold;
  position: absolute;
  color: white;
  top: 38px;
  left: 15px;
`;

export const SidebarBranding = ({ isOpen }: { isOpen: boolean }) => {
  const isMobile = useIsMobile();

  const date = new Date();
  const isChristmasPeriod = date.getMonth() === 11;

  const LogoFullComponent = isChristmasPeriod ? ChristmasLogoFull : LogoFull;
  const LogoSmallComponent = isChristmasPeriod ? ChristmasLogoSmall : LogoSmall;
  const isRotatedLogo = !isChristmasPeriod;

  return (
    <>
      <LogoWrapper>
        <SidebarLogo isMobile={isMobile} isRotatedLogo={isRotatedLogo}>
          {isOpen ? (
            <LogoFullComponent
              isMobile={isMobile}
              color={logoColor}
              dashed={false}
            />
          ) : (
            <LogoSmallComponent
              isMobile={isMobile}
              color={logoColor}
              dashed={false}
            />
          )}
        </SidebarLogo>
      </LogoWrapper>
      {(process.env.REACT_APP_PREVIEW || "") === "true" && (
        <PreviewWrapper>PREVIEW</PreviewWrapper>
      )}
      <Divider />
    </>
  );
};
